//import { getLogger } from '@nerdwallet/logging';
import { isWindowObjectAvailable } from '../utilities/utils';

//const rootLogger = getLogger('local-storage-helper');

interface HelperProps {
  funcName: string;
  name?: string;
  value?: any;
}

/*
 * Checks whether the localStorage is accessible.
 *
 * If the user disables cookies, the browser will not allow access to
 * localStorage and `SecurityError: The operation is insecure.` will be thrown.
 * http://diveintohtml5.info/detect.html#storage
 */
export const supportsLocalStorage = (): boolean => {
  try {
    if (!isWindowObjectAvailable()) {
      return false;
    }

    return 'localStorage' in window && window.localStorage !== null;
  } catch (e) {
    return false;
  }
};

const callLocalStorage = ({ funcName, name, value }: HelperProps) => {
  //const logger = getLogger('callLocalStorage', rootLogger);

  try {
    if (supportsLocalStorage()) {
      return localStorage[funcName](name, value);
    }

    //logger.warn('Browser has no access to localStorage');
    return undefined;
  } catch (e) {
    //logger.warn('Error accessing localStorage', e);
    return undefined;
  }
};

const localStorageHelper = {
  getItem: (name: string): string => {
    //const logger = getLogger('getItem', rootLogger);
    //logger.debug(`Accessing localStorage ${name}`);
    return callLocalStorage({ funcName: 'getItem', name });
  },

  setItem: (name: string, value?: any): string => {
    //const logger = getLogger('setItem', rootLogger);
    //logger.debug(`Accessing localStorage ${name}: ${value}`);
    return callLocalStorage({
      funcName: 'setItem',
      name,
      value,
    });
  },

  clear: (): void => {
    //const logger = getLogger('clear', rootLogger);
    //logger.debug('Accessing localStorage');
    return callLocalStorage({ funcName: 'clearItem' });
  },
};

export default localStorageHelper;
